import React from 'react'
import Box from '../components/Box'

export default function Section12() {
    return (
        <div className="section">
            <h2>Section XII: Help & Support</h2>
            <Box sectionData={'start'} title={'Section XII: Help & Support'} body={`Tap the “Help” button from the main screen and select from the following options:`} />
            
            <Box title={'Customer Support'} body={`Launches the integrated UserVoice support portal where you can view F.A.Qs, submit support
requests, and request new features.`} />

            <Box title={'Knowledge Base'} body={`Launches Safari and opens the online Knowledge Base for GradeBook Pro where you can find the
most up to date support articles.`} />

            <Box title={'Instruction Manual'} body={`This guide will be updated with every release and is intended to be a brief introduction to GradeBook
Pro. Tap the action icon in the top toolbar to open the document in iBooks or another .pdf reader
(helpful for emailing or printing the file).`} />

            <Box title={'Email Support'} body={`Email with questions, suggestions, or general comments. The email will automatically create a
UserVoice support ticket.`} />

            <Box title={'Dropbox Support'} body={'This will launch Safari and the Dropbox help site.'} />

            <Box title={'News & Announcements'} body={`Important news and information about upcoming updates are posted to this site. Stop by or subscribe
via RSS to keep up to date on what is happening with GradeBook Pro.`} />

            <Box title={'Tell a Friend'} body={`Creates an email message with links to GradeBook Pro on the web and the App Store.`} />

            <Box sectionData={'end'} title={'Tweet @GradeBookPro'} body={'Send a tweet for quick questions suitable for public discussion.'} />
        </div>
    )
}
